import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { HeaderList } from "../../../components/HeaderList";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';


const BalanceList = () => {
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();

  const initialize = async () => { 

  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`MENU_FORECAST_ANALYSIS`) + " / " + t(`BALANCE.TITLE_LIST`)} />
    </>
  );
};
export default BalanceList;